<script setup>
import axios from "axios";
import {ref} from "vue";

const order = ref(null);
const errorOccurred = ref(false);
const url = new URL(window.location.href);
const token = url.searchParams.get('token');

axios.get(`GetServiceOrder/${token}`)
  .then(response => {
    order.value = response.data.order;
  })
  .catch(() => {
    errorOccurred.value = true;
  });
</script>

<template>
  <h2>
    Status Twojej wpłaty zaliczki za usługę weterynaryjną
  </h2>
  <div class="wrapper">
    <div class="wrapper__image-aside">
      <img src="@/assets/pies.png" alt="Grafika dekoracyjna">
    </div>
    <div v-if="! errorOccurred" class="container">
      Rozpoczęto płatność dotyczącą zaliczki za usługę weterynaryjną.

      Status Twojej transakcji to:
      <span class="status-pending" v-if="order?.status === 'pending'">
        Płatność oczekuje na zatwierdzenie
      </span>
      <span class="status-success" v-else-if="order?.status === 'success'">
        Płatność zakończona sukcesem. Usługodawca otrzymał zaliczkę.
      </span>
      <span class="status-error" v-else-if="order?.status === 'error'">
        Płatność nie powiodła się
      </span>
      <div>
        <button>
          <router-link to="/">Przejdź do strony głównej</router-link>
        </button>
      </div>
    </div>
    <div v-if="errorOccurred" class="container">
      Nie udało się pobrać danych wskazanej płatności.
      <div>
        <button>
          <router-link to="/">Przejdź do strony głównej</router-link>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
h2 {
  text-align: center;
  font-size: 3.5rem;
}

.wrapper{
  display: flex;
  justify-content: center;
  gap: 80px;
  &__image-aside{
    max-width: 250px;
    img{
      width: 100%;
    }
    flex: 1;
  }

  .container{
    flex: 2;
  }
}

button{
  background-color: #F2790F;
  padding: 8px 15px;
  border-radius: 8px;
  border: none;
  margin-top: 20px;
  a {
    text-decoration: none;
    color: black;
  }
}

.status-pending{
  font-weight: bold;
  color: #F2790F;
}

.status-success{
  font-weight: bold;
  color: #008000;
}

.status-error{
  font-weight: bold;
  color: #FF0000;
}
</style>